import React, {useEffect, useMemo} from "react";
import {BoxRenderProps} from "@components/grid/BoxesGrid";
import {useNavigate} from "react-router-dom";
import {useCollectionRemoveSeriesMutation} from "@mwServices/User";
import {showResponse} from "@services/Api";
import moment from "moment/moment";
import useSubscriptionType from "@hooks/useSubscriptionType";
import {useRefreshUserSeriesFmvMutation} from "@mwServices/Series";
import MyCollectionSeriesListItemDesktop from "@mwPages/my-collection/series/MyCollectionSeriesListItemDesktop";
import MyCollectionSeriesListItemMobile from "@mwPages/my-collection/series/MyCollectionSeriesListItemMobile";
import {useWindowSize} from "@components/window-size-provider";
import {SeriesRenderProps} from "@components/grid/SeriesGrid";

const MyCollectionSeriesListItem = ({
    item,
    showEditMultiple,
    isSelected,
    toggleSelected,
    showDesktopView,
}: SeriesRenderProps) => {
    const windowDimensions = useWindowSize();
    const series = item;
    const navigate = useNavigate();
    const [removeSeriesFromCollection, removeSeriesFromCollectionResponse] = useCollectionRemoveSeriesMutation();
    const [postRefreshFmv, refreshFmvResponse] = useRefreshUserSeriesFmvMutation();

    const subscriptionType = useSubscriptionType();
    const showTotalFmv = useMemo(() => ( subscriptionType.isTrial || subscriptionType.isUnlimited), [subscriptionType]);

    const fmvUpdated = useMemo(() => item && item.fmv_updated ? moment(item.fmv_updated).toDate() : null, [item]);

    useEffect(() => {
        showResponse(removeSeriesFromCollectionResponse, 'Series removed from collection.', 'Sorry, there was a problem removing the series from the collection.');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [removeSeriesFromCollectionResponse]);

    useEffect(() => {
        showResponse(refreshFmvResponse, 'Series fmv refreshed.', 'Sorry, there was a problem refreshing the series FMV.');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshFmvResponse]);

    const hasIcons = useMemo(() => {
        return series.overview.items_key > 0 || series.overview.items_hot > 0 || series.overview.items_rare > 0;
    }, [item]);

    return showDesktopView ? (
        <MyCollectionSeriesListItemDesktop
            series={series}
            showEditMultiple={showEditMultiple}
            isSelected={isSelected}
            toggleSelected={toggleSelected}
            navigate={navigate}
            hasIcons={hasIcons}
            postRefreshFmv={postRefreshFmv}
            showTotalFmv={showTotalFmv}
            refreshFmvResponse={refreshFmvResponse}
            fmvUpdated={fmvUpdated}
            removeSeriesFromCollection={removeSeriesFromCollection}
            windowDimensions={windowDimensions}
        />
    ) : (
        <MyCollectionSeriesListItemMobile
            series={series}
            showEditMultiple={showEditMultiple}
            isSelected={isSelected}
            toggleSelected={toggleSelected}
            navigate={navigate}
            hasIcons={hasIcons}
            postRefreshFmv={postRefreshFmv}
            showTotalFmv={showTotalFmv}
            refreshFmvResponse={refreshFmvResponse}
            fmvUpdated={fmvUpdated}
            removeSeriesFromCollection={removeSeriesFromCollection}
        />
    );

};

export default MyCollectionSeriesListItem;